const appRoutes = {
    home: {
        es: "/es/inicio",
        en: "/en/home",
        pt: "/pt/inicio"
    },
    rooms: {
        es: "/es/departamentos",
        en: "/en/rooms",
        pt: "/pt/quartos"
    },
    outside: {
        es: "/es/exterior",
        en: "/en/outdoor",
        pt: "/pt/exterior"
    },
    contact: {
        es: "/es/contacto",
        en: "/en/contact",
        pt: "/pt/contato"
    },
    book: {
        es: "/es/reservar",
        en: "/en/book",
        pt: "/pt/reservar"
    }
}

// Devolver la ruta correspondiente de la ruta actual en el idioma especificado.
const mapRoute = (currentPath: string, lang: "es" | "en" | "pt"): string => {
    for (const value of Object.values(appRoutes)) {
        if (Object.values(value).includes(currentPath)) {
            return value[lang]
        }   
    }
    return "/";
}

export default mapRoute;
